export function removeUndefinedValues(properties) {
    if (properties === undefined)
        return;
    return JSON.parse(JSON.stringify(properties));
}
//# sourceMappingURL=removeUndefinedValues.js.map